import type { RecipientCountResponse } from '../models/RecipientCountResponse';
import type { RecipientFilter } from '../models/RegistrationMailSendRequest';
import type { RegistrationMailPreviewResponse } from '../models/RegistrationMailPreviewResponse';
import type { RegistrationMailSendRequest } from '../models/RegistrationMailSendRequest';
import type { RegistrationMailSendStatus } from '../models/RegistrationMailSendStatus';
import type { RegistrationMailTemplate } from '../models/RegistrationMailTemplate';
import type { RegistrationMailTestMail } from '../models/RegistrationMailTestMail';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type TDataSaveRegistrationMailTemplateApiV1RegistrationMailTemplatePut = {
	requestBody: RegistrationMailTemplate;
};

export type TDataPreviewRegistrationMailTemplateApiV1RegistrationMailPreviewPost = {
	requestBody: RegistrationMailTemplate;
};

export type TDataSendRegistrationMailTestApiV1RegistrationMailTestPost = {
	requestBody: RegistrationMailTestMail;
};

export type TDataUploadRegistrationMailAttachmentApiV1RegistrationMailTemplateAttachmentsPost = {
	formData: {
		file: Blob;
	};
};

export type TDataDeleteRegistrationMailAttachmentApiV1RegistrationMailTemplateAttachmentsAttachmentIdDelete = {
	attachmentId: string;
};

export type TDataGetRegistrationMailRecipientCountApiV1RegistrationMailRecipientCountGet = {
	recipientFilter?: RecipientFilter;
};

export type TDataSendRegistrationMailApiV1RegistrationMailSendPost = {
	requestBody: RegistrationMailSendRequest;
};

export class RegistrationMailService {

	public static getRegistrationMailTemplateApiV1RegistrationMailTemplateGet(): CancelablePromise<RegistrationMailTemplate> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/registration/mail/template',
		});
	}

	public static saveRegistrationMailTemplateApiV1RegistrationMailTemplatePut(
		data: TDataSaveRegistrationMailTemplateApiV1RegistrationMailTemplatePut,
	): CancelablePromise<RegistrationMailTemplate> {
		const {requestBody} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/registration/mail/template',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	public static uploadRegistrationMailAttachmentApiV1RegistrationMailTemplateAttachmentsPost(
		data: TDataUploadRegistrationMailAttachmentApiV1RegistrationMailTemplateAttachmentsPost,
	): CancelablePromise<RegistrationMailTemplate> {
		const {formData} = data;
		const body = new FormData();
		body.append('file', formData.file);
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/registration/mail/template/attachments',
			body,
			errors: {
				422: `Validation Error`,
			},
		});
	}

	public static deleteRegistrationMailAttachmentApiV1RegistrationMailTemplateAttachmentsAttachmentIdDelete(
		data: TDataDeleteRegistrationMailAttachmentApiV1RegistrationMailTemplateAttachmentsAttachmentIdDelete,
	): CancelablePromise<RegistrationMailTemplate> {
		const {attachmentId} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/registration/mail/template/attachments/{attachment_id}',
			path: {
				attachment_id: attachmentId,
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	public static previewRegistrationMailTemplateApiV1RegistrationMailPreviewPost(
		data: TDataPreviewRegistrationMailTemplateApiV1RegistrationMailPreviewPost,
	): CancelablePromise<RegistrationMailPreviewResponse> {
		const {requestBody} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/registration/mail/preview',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	public static sendRegistrationMailTestApiV1RegistrationMailTestPost(
		data: TDataSendRegistrationMailTestApiV1RegistrationMailTestPost,
	): CancelablePromise<unknown> {
		const {requestBody} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/registration/mail/test',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	public static getRegistrationMailRecipientCountApiV1RegistrationMailRecipientCountGet(
		data: TDataGetRegistrationMailRecipientCountApiV1RegistrationMailRecipientCountGet = {},
	): CancelablePromise<RecipientCountResponse> {
		const {recipientFilter} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/registration/mail/recipient-count',
			query: {
				recipient_filter: recipientFilter,
			},
		});
	}

	public static getRegistrationMailSendStatusApiV1RegistrationMailSendStatusGet(): CancelablePromise<RegistrationMailSendStatus> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/registration/mail/send-status',
		});
	}

	public static cancelRegistrationMailSendApiV1RegistrationMailSendCancelPost(): CancelablePromise<unknown> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/registration/mail/send-cancel',
		});
	}

	public static sendRegistrationMailApiV1RegistrationMailSendPost(
		data: TDataSendRegistrationMailApiV1RegistrationMailSendPost,
	): CancelablePromise<unknown> {
		const {requestBody} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/registration/mail/send',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}
